import { PatientEncounterReport } from 'components/templates';
import React from 'react';

export const EncounterReportView = () => {
  return (
    <div>
      <PatientEncounterReport />
    </div>
  );
};
